import React from "react";
import { useTransition, animated } from "react-spring";

interface AnimatedText {
  className?: string;
  value: string | number;
  prefix?: string | number;
  suffix?: string | number;
  isMobile?: boolean;
}
export default ({
  className,
  value,
  prefix,
  suffix,
  isMobile
}: AnimatedText) => {
  const transition = useTransition(value, item => item, {
    from: {
      position: "absolute",
      opacity: 0,
      transform: "translate3d(-50%,20px,0)",
      left: "50%"
    },
    enter: { opacity: 1, transform: "translate3d(-50%,0px,0)", left: "50%" },
    leave: { opacity: 0, transform: "translate3d(-50%,-20px,0)", left: "50%" }
  });

  return (
    <div
      className={className}
      style={{ position: "relative", whiteSpace: "nowrap", display: "inline" }}
    >
      {transition.map(({ item, props, key }) => (
        <animated.div style={props} key={key}>
          {isMobile ? !isMobile && prefix : prefix} {item} {suffix}
        </animated.div>
      ))}
    </div>
  );
};
